const ReleaseNotesRoute = {
  path: '/Application/ReleaseNotes',
  load: () => import('./ReleaseNotes'),
  protected: true,
};

export { ReleaseNotesRoute };
